import React, { useEffect, useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import NonlalinDisposisi from '../../../utilities/nonlalin/NonlalinDisposisi'
import TransaksiService from '../../../services/transaksi/TransaksiService'
import PbUmkuService from '../../../services/pbumku/PbumkuService'
import UserService from '../../../services/user/UserService'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import { AsyncPaginate } from 'react-select-async-paginate'
import DataTable from 'react-data-table-component'
import ExpandableComponentNonLalinPnbpV2 from '../expand/ExpandableComponentNonLalinPnbpV2'
import { getCurrentDateFormatted, romanNum } from '../../../utilities/Utils'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalPnbpNonLalinV2 = ({ showAddPnbp, handleCloseAddPnbp, dataDisposisi, datappm, reloadList, isEdit }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let userService = useMemo(() => new UserService(), [])
    let nonLalinService = useMemo(() => new NonlalinService(), [])

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)
    const [dataDetil, setDataDetil] = useState(null)
    const [dataDetilPeriksa, setDataDetilPeriksa] = useState(null)

    useEffect(() => {
        if (!datappm) return
        const fetchAllData = async () => {
            try {
                const resDtl = await nonLalinService.listNonlalinDtlAll(datappm.nomorAju)
                setDataDetil(resDtl.data)

                const resDtlPeriksa = await nonLalinService.listNonlalinDtlPeriksaAllByAju(datappm.nomorAju)
                setDataDetilPeriksa(resDtlPeriksa.data.data)

                if(dataDisposisi.nipPejabat !== undefined && dataDisposisi.nipPejabat !== null){
                    const resPegawai = await userService.getPegawaiById(dataDisposisi.nipPejabat)
                    // console.log(resPegawai)
                    setValuePejabatOpt(resPegawai.data)
                }
            } catch (error) {
                console.log(error)
                setDataDetil(null)
                setDataDetilPeriksa(null)
            }
        }
        fetchAllData()
    }, [datappm, nonLalinService, dataDisposisi, userService])

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const handleClickBatal = () => {
        handleCloseAddPnbp()
    }

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trNonlalinDtlPK'].seri,
            grow: 0
        },
        {
            name: 'Nama Dagang',
            cell: row => row['namaLokal']
        },
        {
            name: 'Nama Latin',
            cell: row => row['namaLatin']
        },
        {
            name: 'Keterangan / Populasi',
            cell: row => row['populasi']
        },
    ]

    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const [loadingSave, setLoadingSave] = useState(false)
    const handleConfirmSave = () => {
        setShowConfirmSave(true)
    }
    const [showSaveSuccess, setShowSaveSuccess] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const handleClickSave = async () => {
        setLoadingSave(true)
        try {
            const respNomor = await pbumkuService.ambilNomorService("NLL_PNBP", datappm.kodeUpt, currentYear, localStorage.getItem('username'))
            let noSuratTugas = respNomor.data.uraianPusat + '/' + respNomor.data.kodePusat + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsonPnbp = { ...dataDisposisi, noTugas: noSuratTugas, tglTugas: getCurrentDateFormatted(), nipPejabat: valuePejabatOpt.nip, nmPejabat: valuePejabatOpt.nama, createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resPnbp = await nonLalinService.saveNonlalinPenugasan(jsonPnbp)
            if (_resPnbp.data.kode === '200') {
                let jsonPnbp = {
                    nomorAju: datappm.nomorAju,
                    noPnbp: noSuratTugas,
                    tglPnbp: getCurrentDateFormatted(),
                    created: new Date(),
                    // total: tarifPnbp !== null ? (tarifPnbp.tarif * valueVolume) : null,
                    pejabat: valuePejabatOpt.nip
                }
                const resPnbp = await transaksiService.addPnbp(jsonPnbp)
                if (resPnbp.data.kode === '200') {

                    const idPnbp = resPnbp.data.id
                    dataDetilPeriksa && dataDetilPeriksa.map(async (dataPnbp) => {
                        let jsonPnbpDtl = {
                            nomorAju: dataPnbp.trNonlalinDtlPeriksaPK.nomorAju,
                            kodeTarif: dataPnbp !== null ? dataPnbp.kdTarif : '',
                            volume: dataPnbp !== null ? dataPnbp.volume : 0,
                            satuan: dataPnbp !== null ? dataPnbp.satuan : '',
                            pembagi: dataPnbp !== null ? dataPnbp.pembagi : null,
                            totalTarif: dataPnbp !== null ? (dataPnbp.tarif * dataPnbp.volume) : 0,
                            idPnbp: idPnbp
                        }
                        await transaksiService.addPnbpDetil(jsonPnbpDtl)
                    })
                    let jsonppm = { ...datappm, status: '028' }
                    await nonLalinService.saveNonlalinHeader(jsonppm)

                    let dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '028',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))

                    setShowConfirmSave(false)
                    setShowSaveSuccess(true)
                } else {
                    setShowConfirmSave(false)
                    setShowSaveFailed(true)
                }
            } else {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
            }

        } catch (error) {
            console.log(error)
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
        setLoadingSave(false)
    }


    const handleClickSaveSuccess = () => {
        setShowSaveSuccess(false)
        reloadList(0, 10)
        handleClickBatal()
    }
    const handleClickSaveFailed = () => {
        setShowSaveFailed(false)
    }

    return (
        <>
            <Modal
                show={showAddPnbp}
                onHide={handleCloseAddPnbp}
                backdrop='static'
                size='xl'
                centered
                scrollable
            >
                <Modal.Header closeButton><h6><NonlalinDisposisi idDisposisi={dataDisposisi.idDisposisi} /></h6></Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Bendahara<span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                                isDisabled={!isEdit}
                            />
                        </div>
                    </div>
                    {
                        dataDetil &&
                        <div>
                            <DataTable
                                customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                columns={columns}
                                data={dataDetil.data}
                                highlightOnHover
                                persistTableHead={true}
                                expandableRows
                                expandOnRowDoubleClicked
                                expandableIcon={{
                                    collapsed: <span style={{ color: 'blue', fontWeight: 'bold' }}>Proses</span>,
                                    expanded: <span style={{ color: 'red', fontWeight: 'bold' }}>Tutup</span>,
                                }}
                                expandableRowsComponent={({ data }) => <ExpandableComponentNonLalinPnbpV2 data={data} />}
                                expandableRowExpanded={() => true}
                            />
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleConfirmSave()}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickBatal()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data PNBP ?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSave}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    title="Simpan PNBP Berhasil"
                    success
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    title="Simpan PNBP Gagal"
                    danger
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalPnbpNonLalinV2